'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\toutline: none;\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding-left: 0px;\n\twidth: 40px;\n\theight: 40px;\n\t', ';\n\t', ';\n\t& > svg {\n\t\tmargin-right: 10px;\n\t}\n'], ['\n\toutline: none;\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding-left: 0px;\n\twidth: 40px;\n\theight: 40px;\n\t', ';\n\t', ';\n\t& > svg {\n\t\tmargin-right: 10px;\n\t}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = _styledComponents2.default.button(_templateObject, function (_ref) {
	var disabled = _ref.disabled;
	return disabled && 'pointer-events: none;';
}, function (_ref2) {
	var isMobile = _ref2.isMobile;
	return 'margin-top: ' + (0, _getSize2.default)(isMobile ? _sizes.Sizes.xs : _sizes.Sizes.sm) + 'px;';
});

var BackButton = function (_Component) {
	_inherits(BackButton, _Component);

	function BackButton() {
		_classCallCheck(this, BackButton);

		return _possibleConstructorReturn(this, (BackButton.__proto__ || Object.getPrototypeOf(BackButton)).apply(this, arguments));
	}

	_createClass(BackButton, [{
		key: 'getIcon',
		value: function getIcon(primary) {
			return _react2.default.createElement(
				'svg',
				{ id: 'arrow-backward-outlined', xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
				_react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: '24', height: '24', fill: 'transparent' }),
				_react2.default.createElement('path', { id: 'Icon_color', fill: primary, 'data-name': 'Icon color', d: 'M20,6.5v1a.5.5,0,0,1-.5.5H3.33l4.45,4.44a.5.5,0,0,1,0,.71l-.71.7a.5.5,0,0,1-.71,0L.22,7.718A.75.75,0,0,1,0,7.188v-.38a.77.77,0,0,1,.22-.53L6.36.148a.5.5,0,0,1,.71,0l.71.71a.49.49,0,0,1,0,.7L3.33,6H19.5A.5.5,0,0,1,20,6.5Z', transform: 'translate(2 5.002)' })
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var isMobile = this.context.screen.isMobile;
			var isDesktop = this.context.screen.isDesktop;

			return _react2.default.createElement(
				Button,
				{ disabled: this.props.disabled, onClick: function onClick() {
						return _this2.props.clickEvent();
					}, isMobile: isMobile, isDesktop: isDesktop },
				this.getIcon(_colors.Colors.Primary)
			);
		}
	}]);

	return BackButton;
}(_react.Component);

BackButton.contextTypes = {
	screen: _propTypes2.default.object
};

exports.default = BackButton;